"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.levels = void 0;
var levels = [{
  tier: 1,
  label: 'Platinum',
  color: '#B1B4BF'
}, {
  tier: 2,
  label: 'Gold',
  color: '#ffdf28'
}, {
  tier: 3,
  label: 'Silver',
  color: '#c0c0c0'
}, {
  tier: 4,
  label: 'Bronze',
  color: '#8c7853'
}, {
  tier: 5,
  label: 'Media Partner',
  color: '#a1d5e3'
}, {
  tier: 6,
  label: 'Press',
  color: '#f3c1a0'
}, {
  tier: 7,
  label: 'Startup Alley',
  color: '#aedda6'
}];
exports.levels = levels;